import React from 'react'
import {RegistrationForm} from './RegistrationForm'

export function Registration() {
  return <RegistrationForm />
}
